var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tab_header"},_vm._l((_vm.items),function(item,title){return _c('a',{key:title,class:{'router-link-active' : _vm.sportValue === title},attrs:{"href":title},on:{"click":function($event){$event.preventDefault();return _vm.change(title)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }